/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Select, SelectOption, STATES } from 'sarsaparilla';

const VEHICLE_STATE_OPTIONS = [...STATES, { label: 'OTHER', value: 'OTHER' }];

export default function VehicleStatePicker({
    id,
    isDisabled,
    isRequired,

    label = 'State',
    onChange,
    placeholder = 'Choose a state ...',
    value,
}) {
    return (
        <Select
            id={id}
            isDisabled={isDisabled}
            isRequired={isRequired}
            label={label}
            onChange={onChange}
            placeholder={placeholder}
            value={value}
        >
            {VEHICLE_STATE_OPTIONS.map((option) => (
                <SelectOption key={option.value} value={option.value}>
                    {option.label}
                </SelectOption>
            ))}
        </Select>
    );
}

VehicleStatePicker.propTypes = {
    id: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    label: PropTypes.node,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string,
};
